import { Component, Input, OnInit } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ModalController, RadioGroupChangeEventDetail } from '@ionic/angular';
import { firstValueFrom, forkJoin } from 'rxjs';
import { City } from 'src/app/interfaces/api/city';
import { DeliveryStatus } from 'src/app/interfaces/api/courier';
import { CourierService } from 'src/app/services/courier.service';
import { GoogleMapsService } from 'src/app/services/google-maps.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-modal-detil-pengiriman',
  templateUrl: './modal-detil-pengiriman.component.html',
  styleUrls: ['./modal-detil-pengiriman.component.scss'],
})
export class ModalDetilPengirimanComponent implements OnInit {
  @Input() transactionId: number;
  listStatus: DeliveryStatus[];
  isLoading = true;

  constructor(
    private modalController: ModalController,
    private courierService: CourierService,
    private googleMapsService: GoogleMapsService,
  ) {}

  async ngOnInit() {
    await this.loadData(null);
  }

  async loadData(event) {
    this.isLoading = true;
    const deliveryStatusReq = this.courierService.getTransactionCourierStatus(this.transactionId);

    // forkJoin([deliveryStatusReq]).subscribe({
    //   next: async ([deliveryStatusRes]) => {
    //     this.listStatus = deliveryStatusRes.data.reverse();
    //   },
    //   complete: () => {
    //     this.isLoading = false;
    //     event?.target?.complete();
    //   },
    // });

    const deliveryStatusRes = await firstValueFrom(deliveryStatusReq);
    this.listStatus = deliveryStatusRes.data.reverse();

    if (this.listStatus.length > 0) {
      this.listStatus.map(async status => {
        if (!status.latitude || !status.longitude) {
          return;
        }

        const reverseGeocodingRes = await firstValueFrom(
          this.googleMapsService.reverseGeocoding(Number(status.latitude), Number(status.longitude)),
        );

        if (!reverseGeocodingRes.results || reverseGeocodingRes.results.length === 0) {
          return;
        }

        const location = reverseGeocodingRes.results[0].formatted_address;

        status.address = location;
      });
    }

    this.isLoading = false;
  }

  async cancel() {
    this.modalController.dismiss(null, 'cancel');
  }
}
